import { Directive } from '@angular/core';

@Directive({
  selector: '[nbSuffix]',
})
export class NbSuffixDirective {
}
